import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/pickup-and-store-services.jpg'),
    alt: 'pickup and store services page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'pickup and store services page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Fast <span>Pickup</span><span>And Store Services Available</span>',
  description:
    "Need a hassle-free way to store your belongings? Our Pickup and Store Services provide a convenient solution for those who want their items picked up and stored securely without any effort. Simply schedule a pickup, and we'll handle the rest!",
  image: {
    url: '/images/v2/pages/landing-pages/pickup-and-store-services/hero-image.jpg',
    alt: 'Fast Pickup And Store Services Available'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Schedule Your Pickup Now' }
}

export const ourProcessSectionContent = {
  title: 'How Pickup and Store Services Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/pickup-and-store-services/how-pickup-and-store-services-work.png',
    alt: 'How Pickup and Store Services Work'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Pickup Scheduling',
      description:
        'Simply book a pickup time that works for you, and our team will come to your location to collect your items.',
      image: {
        src: '/images/v2/pages/landing-pages/pickup-and-store-services/easy-pickup-scheduling.png',
        alt: 'Easy Pickup Scheduling'
      }
    },
    {
      id: 2,
      title: 'Secure and Organized Storage',
      description:
        'We store your items in safe, clean, and well-maintained facilities, keeping everything secure and accessible whenever you need it.',
      image: {
        src: '/images/v2/pages/landing-pages/pickup-and-store-services/secure-and-organized-storage.png',
        alt: 'Secure and Organized Storage'
      }
    },
    {
      id: 3,
      title: 'Flexible Storage Options',
      description:
        'Whether you need short-term or long-term storage, we offer flexible plans to accommodate your needs.',
      image: {
        src: '/images/v2/pages/landing-pages/pickup-and-store-services/flexible-storage-options.png',
        alt: 'Flexible Storage Options'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Reliable Pickup And Storage Solutions',
  description:
    'Pickup and Store Services offer an effortless way to store your belongings, with the added convenience of professional pickup and secure storage. Perfect for anyone who needs extra space without the hassle of transporting items themselves.',
  image: {
    src: '/images/v2/pages/landing-pages/pickup-and-store-services/reliable-pickup-and-storage-solutions.jpg',
    alt: 'Reliable Pickup And Storage Solutions'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Pickup and Store Services',

  cards: [
    {
      id: 1,
      title: 'Convenience',
      description:
        'Forget about transporting your items to a storage facility. We pick up your belongings and store them securely.',
      image: {
        src: '/images/v2/pages/common/easy-access-and-convenience.png',
        alt: 'Convenience'
      }
    },
    {
      id: 2,
      title: 'Flexible Storage Options',
      description:
        "Choose from a variety of storage durations and sizes to fit your needs, whether it's for a few days or several months.",
      image: {
        src: '/images/v2/pages/common/improved-compliance.png',
        alt: 'Flexible Storage Options'
      }
    },
    {
      id: 3,
      title: 'Safe and Secure Storage',
      description:
        'Your items are stored in secure, climate-controlled units with 24/7 surveillance to ensure their safety.',
      image: {
        src: '/images/v2/pages/common/enhanced-security2.png',
        alt: 'Safe and Secure Storage'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Pickup and Store Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'People Moving',
          description:
            "If you're in the middle of a move, our pickup and store services can make storing your belongings a lot easier."
        },
        {
          id: 2,
          title: 'Renovators',
          description:
            "Store your furniture, appliances, and other items while you're renovating your home, keeping them safe from damage."
        },
        {
          id: 3,
          title: 'Students',
          description:
            'Perfect for storing items during the summer or between semesters without the hassle of hauling everything yourself.'
        },
        {
          id: 4,
          title: 'Busy Professionals',
          description:
            'If you don’t have the time to visit a storage facility, our pickup service makes storing items easy and efficient.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/pickup-and-store-services/who-should-use-pickup-and-store-services.jpg',
        alt: 'Who Should Use Pickup and Store Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Pickup and Store Services',

  cards: [
    {
      id: 1,
      title: 'Residential Pickup and Storage',
      description:
        'Store your household items, furniture, or seasonal gear with our safe and secure residential storage options.',
      image: {
        src: '/images/v2/pages/common/short-term-storage.png',
        alt: 'Residential Pickup and Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Long-Term Pickup and Storage',
      description:
        'Need long-term storage? We offer flexible options for storing items for extended periods, with easy access when you need it.',
      image: {
        src: '/images/v2/pages/common/long-term-storage.png',
        alt: 'Long-Term Pickup and Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Business Pickup and Storage',
      description:
        'Store office equipment, inventory, or documents without the hassle of transporting them to a facility yourself.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Pickup and Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Short-Term Pickup and Storage',
      description:
        'For short-term needs, we provide affordable, secure storage options with quick pickup and easy access.',
      image: {
        src: '/images/v2/pages/common/short-term-rental-solutions.png',
        alt: 'Short-Term Pickup and Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Pickup and Store Services?',

  image: {
    url: '/images/v2/pages/landing-pages/pickup-and-store-services/why-choose-us-for-pickup-and-store-services.jpg',
    alt: 'Why Choose Us for Pickup and Store Services?'
  },

  articles: [
    {
      id: 1,
      title: 'Convenient Pickup Times',
      description:
        'You can select the pickup time that fits your schedule, making it easy to get started without interrupting your day.'
    },
    {
      id: 2,
      title: 'Flexibility',
      description:
        'Choose the storage size and duration that works best for you, whether you need just a few boxes or an entire home’s worth of storage.'
    },
    {
      id: 3,
      title: 'Affordable Storage Rates',
      description: 'Our pricing is competitive and transparent, with no hidden fees, so you only pay for what you need.'
    },
    {
      id: 4,
      title: 'Hassle-Free Pickup',
      description:
        'Our team handles all the heavy lifting, so you don’t have to worry about transporting your items to the facility.'
    },
    {
      id: 5,
      title: 'Safe and Secure Facilities',
      description: 'Your items are stored in secure, monitored facilities, ensuring they stay in excellent condition.'
    },
    {
      id: 6,
      title: 'On-Demand Delivery',
      description:
        'When you need your items back, we offer quick and easy delivery options, tailored to your schedule and location.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Pickup And Store Services Fast And Reliable',
  description:
    'Fast pickup and store services available now. Affordable and reliable solutions for picking up and storing your items safely.',
  image: {
    src: '/images/v2/pages/landing-pages/pickup-and-store-services/pickup-and-store-services-fast-and-reliable.png',
    alt: 'Pickup And Store Services Fast And Reliable'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Book Your Pickup Now' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Storage Partners',
  description: 'We partner with top shipping and storage providers to ensure your items are handled with care.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx provides reliable shipping and delivery services to ensure your belongings are picked up and transported securely.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL supports our pickup and storage services with dependable global shipping solutions for your stored items.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS helps facilitate the safe and timely transportation of your items to and from our storage facilities.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
